// 登录页地址（默认）
export const LOGIN_URL: string = "/login";

// 查船 海康云眸 视屏流播放器页面路径
export const VideoPlayerUrl = `${import.meta.env.VITE_VIDEO_PLAYER_URL}?{dateRange}token={token}&deviceSerial={deviceSerial}&mode={mode}&origin={origin}`;

export const OSS_URL_SUPPLIER = import.meta.env.VITE_OSS_URL_SUPPLIER;

// 首页地址（默认）暂定
export const HOME_URL: string = "/myTask/index";

// 无权限页面
export const NO_PERMISSION_URL: string = "/403";

// 路由白名单地址（本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = ["/500", "/403"];

// 选项卡最大数量
export const MAX_TAG_NUMBER = 10;
